import React, { Component } from 'react';
import axios from 'axios';
import Navbar from './components/navbar';
import Layouts from './components/layouts';
import './Admin.scss';

class Admin extends Component {
  constructor() {
    super();
    this.state = {
      toggle: false,
    };

    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  toggleSidebar() {
    this.setState({
      toggle: !this.state.toggle,
    });
  }

  render() {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem(
      'salom::admin::token'
    ); // send tokken in header

    // response interseptor
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 401) {
          // if response status == 401 (unauthorized) go to login page
          localStorage.removeItem('salom::admin::token');
          localStorage.removeItem('salom::admin::id');
          localStorage.removeItem('salom::admin::full_name');
          localStorage.removeItem('salom::admin::role');
          window.location = '#/login';
        }

        return Promise.reject(error);
      }
    );

    return (
      <div>
        <Navbar toggleSidebar={this.toggleSidebar} toggle={this.state.toggle} />
        <Layouts toggle={this.state.toggle} />
      </div>
    );
  }
}

export default Admin;
